import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import Grid from '@mui/material/Grid2';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { useState } from 'react';
import ExportSitePDFViewModel from './ViewModels/ExportSitePDFViewModel';

interface IProps {
    dialogOpen: boolean;
    handleClose: () => void;
    exportPDF: (exportFilters: ExportSitePDFViewModel) => void;
    hasParking: boolean;
    hasTravelPlan: boolean;
}

export default function ExportSitePDFDialog({ dialogOpen, handleClose, exportPDF, hasParking, hasTravelPlan }: IProps) {
    const [exportFilters, setExportFilters] = useState<ExportSitePDFViewModel>(
        new ExportSitePDFViewModel()
    );

    const onCheckBoxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, checked } = e.target;
        setExportFilters((f) => ({
            ...f,
            [name]: checked,
        }));
    };

    const resetForm = () => {
        setExportFilters(new ExportSitePDFViewModel());
        handleClose();
    };

    const submit = () => {
        exportPDF(exportFilters);
        resetForm();
    };

    return (
        <Dialog open={dialogOpen} onClose={handleClose} maxWidth="xl" fullWidth>
            <DialogTitle>Site Details Export</DialogTitle>
            <DialogContent>
                <Grid container spacing={2}>
                    <Grid size={6}>
                        <Box sx={{ border: '1px solid #ccc', borderRadius: 1, p: 2, mb: 2 }}>
                            <Typography variant="body2" sx={{ mb: 1 }}>
                                Report Options
                            </Typography>

                            <FormGroup>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={exportFilters.addUserComments}
                                            name="addUserComments"
                                            onChange={onCheckBoxChange}
                                        />
                                    }
                                    label="Add User comments to Report"
                                />
                                {exportFilters.addUserComments &&
                                    <TextField label="Comments" value={exportFilters.userComments} onChange={(e) => setExportFilters({ ...exportFilters, userComments: e.target.value })} />
                                }
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={exportFilters.displayPDFtoScreen}
                                            name="displayPDFtoScreen"
                                            onChange={onCheckBoxChange}
                                        />
                                    }
                                    label="Display PDF directly to screen"
                                />
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={exportFilters.writePDFtoFileOnServer}
                                            name="writePDFtoFileOnServer"
                                            onChange={onCheckBoxChange}
                                        />
                                    }
                                    label="Write PDF report to file on server"
                                />
                            </FormGroup>

                            <TextField label="File Name" value={exportFilters.fileName} onChange={(e) => setExportFilters({ ...exportFilters, fileName: e.target.value })} />

                        </Box>
                    </Grid>
                    <Grid size={6}>
                        <Box sx={{ border: '1px solid #ccc', borderRadius: 1, p: 2, mb: 2 }}>
                            <Typography variant="body2" sx={{ mb: 1 }}>
                                Export Options
                            </Typography>
                            <FormGroup>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={exportFilters.includeDevelopmentDetails}
                                            name="includeDevelopmentDetails"
                                            onChange={onCheckBoxChange}
                                        />
                                    }
                                    label="Include Development Details"
                                />
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={exportFilters.includeDayDetails}
                                            name="includeDayDetails"
                                            onChange={onCheckBoxChange}
                                        />
                                    }
                                    label="Include Day Details"
                                />
                                {hasParking &&
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                            checked={exportFilters.includeParking}
                                                name="includeParking"
                                                onChange={onCheckBoxChange}
                                            />
                                        }
                                        label="Include Parking Details"
                                    />
                                }
                                {hasTravelPlan &&
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                            checked={exportFilters.includeTravelPlan}
                                                name="includeTravelPlan"
                                                onChange={onCheckBoxChange}
                                            />
                                        }
                                        label="Include Travel Plan Details "
                                    />
                                }
                            </FormGroup>
                        </Box>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={submit}>Export</Button>
                <Button onClick={resetForm}>Cancel</Button>
            </DialogActions>
        </Dialog>
    );
}